import { Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import TopNav from "./components/TopNav";
import About from "./components/pages/About";
import Resume from "./components/pages/Resume";
import Portfolio from "./components/pages/Portfolio";
import Contact from "./components/pages/Contact";
import Gallery from "./components/pages/Gallery";

export default function App() {
  return (
    
    <div className="min-h-screen bg-black text-white flex justify-center items-start py-1 md:py-8">
      <div
        className="
    flex flex-col md:flex-row 
    items-start 
    bg-black 
    rounded-xl shadow-xl 
    max-w-[95rem] w-full mx-4 
     md:gap-10
  "
      >
        {/* Sidebar - fixed/sticky */}

        <aside
          className="
    w-full md:w-[22rem] 
    h-auto md:h-[650px] 
    bg-[#201f1f] rounded-2xl 
    mt-1 md:mt-[50px] 
    border border-gray-700 
    md:sticky md:top-[50px]
  "
        >
          <Sidebar />
        </aside>

        {/* Right content - scrollable */}

        <main
          className="
    flex-1 
    bg-[#201f1f] rounded-2xl 
    mt-3 md:mt-[50px] 
    border border-gray-700  
    overflow-y-auto scrollbar-hide
    w-full
  "
        >
          <div className="flex flex-col">
            
            <div className="hidden md:flex justify-end w-full md:w-auto relative z-50">
              <TopNav />
            </div>

            {/* Page Content */}
            <div className="px-6 py-6">
              <Routes>
                <Route path="/" element={<Navigate to="/about" />} />
                <Route path="/about" element={<About />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/project" element={<Portfolio />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/gallery" element={<Gallery />} />
              </Routes>
            </div>
          </div>
        </main>
        {/* Mobile Bottom Navigation */}
        <div className="md:hidden fixed bottom-0 left-0 w-full z-50">
          <TopNav />
        </div>
      </div>
    </div>
  );
}
